exports.init = function () {
  $('button[data-action-submit]').on('click', function (e) {
    const form = $(e.target).closest('form');
    e.preventDefault();
    form.prop('action', e.target.dataset.actionSubmit);
    setTimeout(function () {
      form.trigger('submit');
    }, 1000);
  });
}
